<div *ngIf="!type" class="save-search-btn" (click)="toggleSearchModalState()">
  <span class="save-search-icon">
    <i
      [ngClass]="{
        'fa-star': (savedSearchId$ | async) !== undefined,
        'fa-star-o': (savedSearchId$ | async) === undefined
      }"
      class="fa"
    ></i>
  </span>
  <span class="save-search-txt">{{ 'SAVE_YOUR_SEARCH' | translate }}</span>
</div>

<div *ngIf="type === 'menu'" class="save-search-btn" (click)="toggleSearchModalState()">
  <span class="save-search-icon">
    <i class="fa fa-cog"></i>
  </span>
</div>
